import { formatarIdadeRelativa } from '@/helpers/formatacao.helpers';
import type { Suporte } from '@/types/status.types';

type RodapeStatusProps = {
  idadeSegundos: number;
  suporte: Suporte;
};

export const RodapeStatus = ({ idadeSegundos, suporte }: RodapeStatusProps) => {
  return (
    <footer className="flex flex-wrap items-baseline gap-x-[18px] gap-y-2 px-1 py-1.5 text-[12px] text-muted-foreground">
      <span>
        Atualizado automaticamente a cada minuto · última verificação{' '}
        {formatarIdadeRelativa(idadeSegundos)}
      </span>
      <div className="flex-1" />
      <a href="#historico">Histórico</a>
      {suporte.telefone && <span>Suporte: {suporte.telefone}</span>}
      {suporte.email && <a href={`mailto:${suporte.email}`}>{suporte.email}</a>}
    </footer>
  );
};
